<nav class="navbar navbar-dark fixed-top bg-dark" style="height: 50px;">
	<div v-if="loading" class="loading-overlay">
		<div class="spinner"></div>
	</div>
	<a class="navbar-brand" href="#" style="margin-left: 15px; font-weight: 500;"><span>ClarityPay</span></a>
	<div class="d-flex">
		<div class="d-none d-sm-flex align-items-center text-white" style="font-size: 13px;">
			{{ currentDateTime }}
		</div>
		<div class="nav-item dropdown" style="padding-left:15px; margin-right: 10px;">
			<button type="button" class="btn btn-outline-secondary btn-sm dropdown-toggle text-white"
				data-bs-toggle="dropdown" aria-expanded="false">
				{{ username }}
			</button>
			<ul class="dropdown-menu" aria-labelledby="navbarDropdown" style="margin-left:-6em">
				<!-- <li><a class="dropdown-item" href="#">User</a></li> -->
				<li><a class="dropdown-item" href="#">Change Password</a></li>
				<li>
					<hr class="dropdown-divider">
				</li>
				<li><a class="dropdown-item" href="#" @click="logout()">Logout</a></li>
			</ul>
		</div>
	</div>
</nav>